import React from "react";
import { Doughnut } from "react-chartjs-2";

const Graph1 = ({ data }) => {
  const data1 = {
    labels: ["Male", "Female", "Others"],
    datasets: [
      {
        label: "",
        data: [data?.male, data?.female, data?.others],
        borderWidth: 1,
      },
    ],
  };

  const option = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      datalabels: { display: true, color: "#fff" },
      legend: {
        position: "bottom",
      },
      colors: {
        forceOverride: true,
      },
    },
  };

  return (
    <div className="bg-white p-3 rounded-3 border">
      <div className="mb-3">
        <h6 className="text-dark fw-bold">Gender wise SDRF</h6>
      </div>
      <div className="chartbox mt-3">
        <Doughnut options={option} data={data1} />
      </div>
    </div>
  );
};

export default Graph1;
